export type AllowedFileTypes = "pdf" | "doc" | "image" | "xml";

export const getAllowedFileMimeTypes = (accepted: AllowedFileTypes[]) =>
  accepted.flatMap((type) => {
    switch (type) {
      case "pdf":
        return ["application/pdf"];
      case "doc":
        return ["application/msword"];
      case "image":
        return ["image/png", "image/jpeg", "image/gif", "image/webp"];
      case "xml":
        return ["text/xml", "application/xml"];
      default:
        return [];
    }
  });
